<template>
  <div id="app">
    <b-card header="<i class='fa fa-magnifier'></i> Pengajuan FTZ">
      <div class="row">
        <div class="mx-3 my-3">
          <input type="text" placeholder="Pencarian" class="form-control" v-model="searchFilter">
        </div>
        <div class="ml-auto pr-3 pb-3" >
          &nbsp;
        </div>
      </div>
      <div v-if="isLoading" style="height: 20rem" class="d-flex align-items-center justify-content-center">
          <half-circle-spinner
            :animation-duration="1000"
            :size="60"
            :color="'#000000'"
          />
        </div>      
      <div class="row" v-if="!isLoading">
        <div class="col-12" style="overflow-y:scroll;">
          <table class="table table-bordered">
            <thead>
              <tr style="cursor: pointer">
                <th @click="sort('NM_PERUSAHAAN')">Nama Perusahaan <i class="fa fa-arrows-v pull-right"></i> </th>
                <th @click="sort('no_mohon')">No Mohon <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('tgl_mohon')">Tgl Mohon <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('no_setuju')">No Setuju <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('tgl_setuju')">Tgl Setuju <i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('nama_ijin')">Jenis Izin<i class="fa fa-arrows-v pull-right"></i></th>
                <th @click="sort('status')">Status<i class="fa fa-arrows-v pull-right"></i></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="bl in pageOfItems" :key="bl.id_rekon_manifes">
                <td>{{bl.NM_PERUSAHAAN}}</td>
                <td>{{bl.no_mohon}}</td>
                <td>{{bl.tgl_mohon}}</td>
                <td>{{bl.no_setuju}}</td>
                <td>{{bl.tgl_setuju}}</td>
                <td>{{bl.nama_ijin}}</td>
                <td :style="'background-color:'+tes(bl.status)">{{bl.ur_status}}</td>
                <td>
                  <router-link class="btn btn-primary" :to="'/browseftz/list/' + bl.id_permohonan" title="Detil Pengajuan"><i class="fa fa-search"></i></router-link>
                  <button title="Catatan Petugas" @click="opencatatan(bl.id_permohonan)" type="button" class="btn btn-success"><i class="fa fa-list-ul" ></i> </button>
                  <button v-if="bl.status == '90' "@click="opennew(bl.id_permohonan)" class="btn btn-warning" title="Ajukan Kembali"><i class="fa fa-edit"></i></button>
                </td>
                
              </tr>
            </tbody>
          </table>
        </div>
        <div class="ml-3 pb-0 pt-3">
            <jw-pagination :items="filteredData" @changePage="onChangePage"></jw-pagination>
        </div>        
      </div>
    </b-card>

    <b-modal fade hide-footer title="Catatan Petugas" size="lg" v-model="ModalCatatan" @ok="ModalCatatan = false">
      <div class="row">
        <div class="col-12">
          <table class="table table-bordered table-sm">
            <thead>
              <tr class="align-middle">
                <th>Nama Pegawai</th>
                <th>Level Pemeriksa</th>
                <th>Catatan</th>
                <th>Wkt Selesai</th>
                <!-- <th>Wkt Konfirmasi</th> -->
              </tr>
            </thead>
            <tbody>
              <tr v-for="catat in catatan" :key="catat.NAMA">
                <td>{{ catat.NAMA }}</td>
                <td>{{ catat.ur_pemeriksa }}</td>
                <td>{{ catat.catatan }}</td>
                <td>{{ catat.wk_selesai }}</td>
                <!-- <td>{{ catat.wk_konfirmasi }}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {HalfCircleSpinner} from 'epic-spinners'
import swal from 'sweetalert'
export default {
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
      searchFilter: '',
      isLoading: true,
      pageOfItems: [],
      ModalCatatan: false,
      catatan: [],
      listBL: [],
      currentSort: 'wk_kirim',
      currentSortDir: 'asc'
      // url: this.$http.options.root
    }
  },
  computed: {
    // dataNhiFiltered () {
    //   return this.datanhi.filter((nhi) => {
    //     return this.searchFilter.toLowerCase().split(' ').every(v => nhi.no_container.toLowerCase().includes(v))
    //   })
    // },
    filteredData: function () {
      return this.listBL.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      }).filter((items) => {
        for (var item in items) {
          if (String(items[item]).toLowerCase().indexOf(this.searchFilter.toLowerCase()) !== -1) {
            return true
          }
        }
        return false
      })
    }
  },
  mounted () {
    this.browse()
  },
  methods: {
    opencatatan (idPermohonan) {
      this.getCatatan(idPermohonan)
    },
    getCatatan (idPermohonan) {
      var idmohon = {
        idijin: idPermohonan
      }
      this.$http.post('bc/petugas/approvecatatanpengguna', idmohon)
        .then(response => {
          this.catatan = response.data
          this.ModalCatatan = true
        })
    },
    sort: function (s) {
      // if s == current sort, reverse
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    browse () {
      var data = {
        user: this.$store.getters['auth/user']['username']
      }
      this.$http.post('browseftz', data).then((response) => {
        this.listBL = response.data
        this.isLoading = false
      })
    },
    onChangePage (pageOfItems) {
    // update page of items
      this.pageOfItems = pageOfItems
    },
    tes (status) {
      var warna
      if (status === '50') {
        warna = 'limegreen'
      } else if (status === '20' || status === '27' || status === '28' || status === '29') {
        warna = 'Yellow'
      } else if (status === '90') {
        warna = 'tomato'
      } else {
        warna = 'White'
      }
      return warna
    },
    opennew (id) {
      swal({
        title: 'Ajukan kembali data permohonan',
        text: 'Anda yakin akan kembali mengajukan data permohonan ini?',
        icon: 'warning',
        buttons: {
          cancel: 'Cancel',
          Yes: 'Yes'
        }
      })
        .then((value) => {
          switch (value) {
            case 'Yes':
              this.isLoading = true
              this.ajukembali(id)
          }
        })
    },
    ajukembali (id) {
      var data = {
        id_permohonan: id
      }
      this.$http.post('ajukembali', data).then((response) => {
        swal(response.data.status, response.data.message, response.data.status)
        this.$router.push('/pengajuanftz/detilheader/' + response.data.id)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Brows/browseftz.vue?c06192b6